import React from "react";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";

const HelpCenter = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        py: { xs: 3, md: 6 },
        px: { xs: 2, sm: 3 },
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      
      {/* Page Title */}
      <Typography
        variant="h3"
        align="center"
        sx={{ fontWeight: "bold", mb: 4, fontSize: { xs: "1.75rem", md: "3rem" } }}
      >
        Help Center
      </Typography>

      {/* Intro Section */}
      <Typography
        variant="body1"
        align="center"
        sx={{ mb: 6, color: "#666", maxWidth: "800px", mx: "auto" }}
      >
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
        ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
        aliquip ex ea commodo consequat.
      </Typography>

      {/* Content Cards */}
      <Grid container spacing={4}>
        
        <Grid item xs={12} md={4}>
          <Paper elevation={3} sx={{ p: 3, height: "100%" }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
              Our Mission
            </Typography>
            <Typography variant="body2" sx={{ color: "#555" }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
              Duis aute irure dolor in reprehenderit in voluptate velit 
              esse cillum dolore eu fugiat nulla pariatur.
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper elevation={3} sx={{ p: 3, height: "100%" }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
              Our Vision
            </Typography>
            <Typography variant="body2" sx={{ color: "#555" }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
              Excepteur sint occaecat cupidatat non proident, sunt in 
              culpa qui officia deserunt mollit anim id est laborum.
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper elevation={3} sx={{ p: 3, height: "100%" }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
              Our Values
            </Typography>
            <Typography variant="body2" sx={{ color: "#555" }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
              Sed ut perspiciatis unde omnis iste natus error sit 
              voluptatem accusantium doloremque laudantium.
            </Typography>
          </Paper>
        </Grid>

      </Grid>

    </Container>
  );
};

export default HelpCenter;